import {
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { useSelector, shallowEqual } from "react-redux";
import PaymentDescriptionTerms from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTerms";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import { isBookingDateEligibleForDeposit } from "app/pages/Booking/bookingSelectors";
import { useShowDepositFlag } from "app/pages/.shared/Deposit/useShowDepositFlag";
import PropTypes from "prop-types";

// AB Test : si le flag deposit est inactif (variation B),
// on force enableDepositDisplay à false pour afficher les termes de paiement classiques (2x, 4x)
// au lieu de la version deposit (acompte %).
const mapStateToProps = state => {
	return {
		availablePaymentTerms: getAvailablePaymentTerms(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		enableDepositDisplay: isDepositEnabled(state),
		isBookingDateEligibleForDeposit: isBookingDateEligibleForDeposit(state),
		onlinePercentage: getPartnerDepositPercentage(state),
	};
};

const PaymentDescriptionTermsContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const showDepositFlagValue = useShowDepositFlag();

	return (
		<PaymentDescriptionTerms
			{...props}
			{...stateProps}
			enableDepositDisplay={showDepositFlagValue ? stateProps.enableDepositDisplay : false}
		/>
	);
};

PaymentDescriptionTermsContainer.propTypes = {
	enableDepositDisplay: PropTypes.bool,
};

export default PaymentDescriptionTermsContainer;
